module.exports = __webpack_public_path__ + "static/media/country-01.000ecf45.png";